import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

export default function ExpenseGroup({ tripId, onGroupCreated, onGroupDeleted, onGroupEdited }) {
  const [groupName, setGroupName] = useState('');
  const [members, setMembers] = useState([{ name: '', email: '' }]);
  const [error, setError] = useState('');

  const handleAddMember = () => {
    setMembers([...members, { name: '', email: '' }]);
  };

  const handleMemberChange = (index, field, value) => {
    const newMembers = [...members];
    newMembers[index][field] = value;
    setMembers(newMembers);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data, error } = await supabase
        .from('expense_groups')
        .insert({
          trip_id: tripId,
          group_name: groupName,
          members: members.filter(m => m.name && m.email)
        })
        .select()
        .single();

      if (error) throw error;
      setGroupName('');
      setMembers([{ name: '', email: '' }]);
      onGroupCreated(data);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow max-w-2xl mx-auto">
      <h3 className="text-lg font-medium mb-4">Create Expense Group</h3>
      {error && <p className="text-red-600 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Group Name</label>
          <input
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          />
        </div>

        <div className="space-y-3">
          <label className="block text-sm font-medium text-gray-700">Members</label>
          {members.map((member, index) => (
            <div key={index} className="flex gap-2">
              <input
                type="text"
                placeholder="Name"
                value={member.name}
                onChange={(e) => handleMemberChange(index, 'name', e.target.value)}
                className="flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Email"
                value={member.email}
                onChange={(e) => handleMemberChange(index, 'email', e.target.value)}
                className="flex-1 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
              />
            </div>
          ))}
        </div>

        <div className="flex justify-between">
          <button
            type="button"
            onClick={handleAddMember}
            className="text-blue-600 hover:text-blue-700"
          >
            + Add Member
          </button>
          <button
            type="submit"
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          >
            Create Group
          </button>
        </div>
      </form>
    </div>
  );
}
